
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.272 3.365C0 3.9 0 4.6 0 6v4c0 1.4 0 2.1.272 2.635a2.5 2.5 0 001.093 1.092C1.9 14 2.6 14 4 14h3c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 001.092-1.092C11 12.1 11 11.4 11 10V6c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 00-1.092-1.093C9.1 2 8.4 2 7 2H4c-1.4 0-2.1 0-2.635.272A2.5 2.5 0 00.272 3.365zm11.766 2.86C12 6.36 12 6.507 12 6.8v2.4c0 .293 0 .44.038.575a1 1 0 00.165.33c.085.111.202.199.437.375l.8.6c.824.618 1.236.927 1.58.92a1 1 0 00.767-.383C16 11.345 16 10.83 16 9.8V6.2c0-1.03 0-1.545-.213-1.817A1 1 0 0015.021 4c-.345-.007-.757.302-1.581.92l-.8.6c-.235.176-.352.264-.437.376a1 1 0 00-.165.33z","fill":"#fff","fill-opacity":".75"}})])
          )
        }
      }
    